(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/services/fetch-personal-results.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/services/fetch-personal-results.js');

const { jupiter } = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const { PromiseStatus } = svs.isServer ?
  require('../../constants/assets/javascripts/promise-status.es6') :
  svs.components.marketplaceCompetition.constants.promiseStatus;
const { settleRequestsSerially } = svs.isServer ?
  require('../../constants/assets/javascripts/settle-requests-serially.es6') :
  svs.components.marketplaceCompetition.constants.settleRequestsSerially;

const getPaths = (competitionId, teamIds, shouldFetchIndividualResults) => {
  const resultsPaths = [];
  if (shouldFetchIndividualResults) {
    resultsPaths.push(`/player/2/competitions/${competitionId}/result`);
  }
  if (teamIds) {
    teamIds.forEach((teamId) => {
      resultsPaths.push(`/player/2/competitions/${competitionId}/team/result?teamId=${teamId}`);
    });
  }
  return resultsPaths;
};

const startPersonalResultsSocket = (competitionId, teamIds, shouldFetchIndividualResults, onUpdate) => {
  if (svs.isServer) {
    return () => {};
  }
  if (!competitionId || typeof onUpdate !== 'function') {
    return () => {};
  }

  const socket = svs.core && svs.core.socket ? svs.core.socket : null;

  if (!socket || typeof socket.subscribe !== 'function' || typeof socket.unsubscribe !== 'function') {
    return () => {};
  }

  const subscriptions = [];
  const paths = getPaths(competitionId, teamIds, shouldFetchIndividualResults);

  paths.forEach((path) => {
    const ctx = {};
    try {
      socket.subscribe(path, (msg) => onUpdate(msg, path), ctx, true, true);
      subscriptions.push({ path, ctx });
    } catch (e) {
      try {
        svs.core.log.getLogger('marketplace:personal-results-socket').warn(`Failed to subscribe to ${path}`, e);
      } catch (__) {}
    }
  });

  return () => {
    subscriptions.forEach(({ path, ctx }) => {
      try {
        socket.unsubscribe(path, ctx);
      } catch (e) {
        try {
          svs.core.log.getLogger('marketplace:personal-results-socket').warn(`Failed to unsubscribe ${path}`, e);
        } catch (__) {}
      }
    });
  };
};

const fetchPersonalResults = async (competitionId, teamIds, shouldFetchIndividualResults, req) => {
  if (!competitionId) {
    return {
      responses: [undefined, undefined]
    };
  }
  const options = {
    method: 'GET',
    req
  };
  const paths = getPaths(competitionId, teamIds, shouldFetchIndividualResults);

  if (!paths.length) {
    return {
      responses: []
    };
  }

  if (paths.length === 1) {
    return jupiter.callAsync({
      ...options,
      path: paths[0],
      req
    });
  }

  const responses = await settleRequestsSerially(paths.map((path) => {
    return () => jupiter.callAsync({
      ...options,
      path,
      req
    });
  }));

  return {
    responses: responses.map((response) => response.status === PromiseStatus.Fulfilled ? response.value : { error: response.reason })
  };
};

if (svs.isServer) {
  module.exports = fetchPersonalResults;
} else {
  setGlobal('svs.components.marketplaceCompetition.services.services.fetchPersonalResults', fetchPersonalResults);
  setGlobal('svs.components.marketplaceCompetition.services.services.startPersonalResultsSocket', startPersonalResultsSocket);
}


 })(window);